import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const PillsContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
});
